<div class="tooltip-container">
  <app-quickaction *ngFor="let action of quickActionService.components" [ref]="action.ref" [position]="action.position" [actions]="action.actions" [actionState]="action.actionState" [color]="action.color" (change)="actionClicked($event)"></app-quickaction>
</div>
